module.exports = __webpack_public_path__ + "assets/img/threatinfomation.ee4a1688.svg";